import { render, staticRenderFns } from "./NumberOfVisitedPagesModal.vue?vue&type=template&id=d3aea6fa&"
import script from "./NumberOfVisitedPagesModal.vue?vue&type=script&lang=js&"
export * from "./NumberOfVisitedPagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports